// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e8b153a9","703":"1bf8b1c3"}[chunkId] + ".chunk.js";
};